<template>
    <div>

        <h2>
<!--        <strong>Sadrokartóny</strong>-->
            {{ category.name }}
        </h2>
        <p>{{ category.perex }}</p>

    </div>
</template>

<script>

    export default {
        props: {
            category: {
                type: Object
            }
        },

    }
</script>
